export class RetailRocket {
    track(callback) {
        (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
            try {
                callback();
            } catch (e) {
                if (isDevelopment) {
                    console.log(e);
                }
            }
        });
    }

    viewContentProduct(product) {
        if (!product) {
            return;
        }

        let callback;
        if (product.is_offers) {
            callback = function () {
                console.log('rr viewContentProduct product offers');
                rrApi.groupView(product.offers_id);
            };
        } else {
            callback = function () {
                console.log('rr viewContentProduct product');
                rrApi.view(product.id);
            };
        }

        this.track(callback);
    }

    viewContentCategory(category) {
        if (!category) {
            return;
        }

        this.track(function () {
            console.log('rr viewContentCategory');
            rrApi.categoryView(category.id);
        });
    }

    setProfile(params) {
        if (!params) {
            return;
        }
        console.log(params);
        this.track(function() {
            console.log('rr setProfile');
            rrApi.setProfile(params);
        });
    }

    /*
    subscription(email) {
        this.track(function() {
            rrApi.setEmail(email);
            rrApi.welcomeSequence(email);
        });
    }

    subscriptionPopup(email) {
        this.track(function() {
            rrApi.setEmail(email, {EmailPopUp: true});
            rrApi.welcomeSequence(email);
        });
    }

    oneClick(productId) {
        this.track(function() {
            rrApi.addToBasket(productId);
        });
    }
    */

    addToCart(product) {
        this.track(function () {
            console.log('rr addToCart');
            rrApi.addToBasket(product.id);
        });
    }

    orderTransaction(order, basket) {
        let params = {
            transaction: order.id,
            items: this.formatBasket(basket)
        };
        this.track(function () {
            console.log('rr orderTransaction');
            rrApi.order(params);
        });
    }

    /*
    productAddToFavorite(params) {
        this.track(function() {
            rrApi.subscribeonpricedrop(params.email, [params.product]);
        });
    }
    */

    formatBasket(basket) {
        return basket.map((basketItem) => {
            return RetailRocket.formatBasketItem(basketItem);
        });
    }

    static formatBasketItem(basketItem) {
        return {
            id: basketItem.offer_id || basketItem.id,
            qnt: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price)
        };
    }
}



// WEBPACK FOOTER //
// ./modules/tracker/retailrocket.js